import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from "@angular/core";

require('./service-progress-bar.scss');
@Component({
  standalone: false,
  selector: 'app-service-progress-bar',
  templateUrl: './service-progress-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceProgressBarComponent implements OnChanges {

  @Input() id: string;
  @Input() progress: any;
  @Input() serviceType: any;

  public isDisableTransition: boolean = false;
  progressValuePercentage: number;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.progress) {

      const currentId = changes.id?.currentValue,
        previousId = changes.id?.previousValue;

      this.isDisableTransition = currentId !== previousId;

      this.progressValuePercentage = 0;
      if (this.progress) {
        this._initProgressBarValue();
      }
    }

  }

  private _initProgressBarValue() {
    if (this.progress.numberOfSteps > 0) {
      this.progressValuePercentage = Math.round((this.progress.stepNumber / this.progress.numberOfSteps) * 100);
    } else {
      this.progressValuePercentage = 0;
    }
  }

}
